import { render, staticRenderFns } from "./Train.vue?vue&type=template&id=e652ec7c&scoped=true&"
import script from "./Train.vue?vue&type=script&lang=js&"
export * from "./Train.vue?vue&type=script&lang=js&"
import style0 from "./Train.vue?vue&type=style&index=0&id=e652ec7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e652ec7c",
  null
  
)

export default component.exports